import { action, createRequestTypes } from '../base';

export const jobWorkActionTypes = {
  JOB_WORKS: createRequestTypes('JOB_WORKS'),
  JOB_WORK_BY_ID: createRequestTypes('JOB_WORK_BY_ID'),
  JOB_WORK_BY_MO_ID: createRequestTypes('JOB_WORK_BY_MO_ID'),
  UPDATE_JOB_WORK: createRequestTypes('UPDATE_JOB_WORK'),
  GET_JOB_OPERATORS: createRequestTypes('GET_JOB_OPERATORS'),
  GET_JOB_WORK_KANBAN: createRequestTypes('GET_JOB_WORK_KANBAN'),
  GET_JOB_WORK_KANBAN_PAGE: createRequestTypes('GET_JOB_WORK_KANBAN_PAGE'),
  PROCESS_JW_MATERIAL: createRequestTypes('PROCESS_JW_MATERIAL'),
  PROCESS_JW_MATERIAL_COMPLETE: createRequestTypes('PROCESS_JW_MATERIAL_COMPLETE'),
  UPDATE_JOB_WORK_V2: createRequestTypes('UPDATE_JOB_WORK_V2'),
  GET_MASTER_PRODUCTION_PROCESS_LIST: createRequestTypes('GET_MASTER_PRODUCTION_PROCESS_LIST'),
  GET_SUB_JOB_CARDS_LIST: createRequestTypes('GET_SUB_JOB_CARDS_LIST'),
  GET_MASTER_PRODUCTION_PROCESS_KANBAN: createRequestTypes('GET_MASTER_PRODUCTION_PROCESS_KANBAN'),
  GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE: createRequestTypes('GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE'),
  GET_SUB_JOB_CARDS_KANBAN: createRequestTypes('GET_SUB_JOB_CARDS_KANBAN'),
  GET_SUB_JOB_CARDS_KANBAN_PAGE: createRequestTypes('GET_SUB_JOB_CARDS_KANBAN_PAGE'),
};

/**
 * @param payload
 * @param orgId
 * @param status
 * @param limit
 * @param page
 * @param callback
 */
class JobWorkActions {
  getJobWorks = (payload, callback) => action(jobWorkActionTypes.JOB_WORKS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} getJobWorksLoading
   * @return
   */
  getJobWorksLoading = (getJobWorksLoading) => action(jobWorkActionTypes.JOB_WORKS.LOADING, {
    getJobWorksLoading,
  })

  /**
   * @return
   * @param jobWorks
   */
  getJobWorksSuccess = (jobWorks) => action(jobWorkActionTypes.JOB_WORKS.SUCCESS, {
    jobWorks,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getJobWorkById = (payload, callback) => action(jobWorkActionTypes.JOB_WORK_BY_ID.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getJobWorkByIdLoading
   * @returns {{type: *}}
   */
  getJobWorkByIdLoading = (getJobWorkByIdLoading) => action(jobWorkActionTypes.JOB_WORK_BY_ID.LOADING, {
    getJobWorkByIdLoading,
  })

  /**
   *
   * @param selectedJobWork
   * @returns {{type: *}}
   */
  getJobWorkByIdSuccess = (selectedJobWork) => action(jobWorkActionTypes.JOB_WORK_BY_ID.SUCCESS, {
    selectedJobWork,
  })

  /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} moId
   * @return
   */
  getJobWorkByMoId = (orgId, tenantId, moId, isListScreen) => action(jobWorkActionTypes.JOB_WORK_BY_MO_ID.REQUEST, {
    orgId, tenantId, moId, isListScreen,
  })

  /**
   *
   * @param {*} getJobWorkByMoIdLoading
   * @return
   */
  getJobWorkByMoIdLoading = (getJobWorkByMoIdLoading) => action(jobWorkActionTypes.JOB_WORK_BY_MO_ID.LOADING, {
    getJobWorkByMoIdLoading,
  })

  /**
   * @return
   * @param moJobWork
   */
  getJobWorkByMoIdSuccess = (moJobWork) => action(jobWorkActionTypes.JOB_WORK_BY_MO_ID.SUCCESS, {
    moJobWork,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  updateJobWork = (payload, callback) => action(jobWorkActionTypes.UPDATE_JOB_WORK.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updateJobWorkLoading
   * @returns {{type: *}}
   */
  updateJobWorkLoading = (updateJobWorkLoading) => action(jobWorkActionTypes.UPDATE_JOB_WORK.LOADING, {
    updateJobWorkLoading,
  })

  /**
 *
 * @param payload
 * @param callback
 * @returns {{type: *}}
 */
  updateJobWorkV2 = (payload, callback) => action(jobWorkActionTypes.UPDATE_JOB_WORK_V2.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updateJobWorkV2Loading
   * @returns {{type: *}}
   */
  updateJobWorkV2Loading = (updateJobWorkV2Loading) => action(jobWorkActionTypes.UPDATE_JOB_WORK_V2.LOADING, {
    updateJobWorkV2Loading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getJobOperators = (payload, callback) => action(jobWorkActionTypes.GET_JOB_OPERATORS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @type {{type: *}}
   */
  getJobOperatorsLoading = (getJobOperatorsLoading) => action(jobWorkActionTypes.GET_JOB_OPERATORS.LOADING, {
    getJobOperatorsLoading,
  })

  /**
   *
   * @type {{type: *}}
   */
  getJobOperatorsSuccess = (jobOperators) => action(jobWorkActionTypes.GET_JOB_OPERATORS.SUCCESS, {
    jobOperators,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getJobWorksKanban = (payload, callback) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getJobWorksKanbanLoading
   * @returns {{type: *}}
   */
  getJobWorksKanbanLoading = (getJobWorksKanbanLoading) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN.LOADING, {
    getJobWorksKanbanLoading,
  })

  /**
   *
   * @param kanbanJobWorks
   * @returns {{type: *}}
   */
  getJobWorksKanbanSuccess = (groupBy, jobWorks) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN.SUCCESS, {
    groupBy, jobWorks,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getJobWorksKanbanPage = (payload, callback) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getJobWorksKanbanPageLoading
   * @returns {{type: *}}
   */
  getJobWorksKanbanPageLoading = (groupBy, getJobWorksKanbanPageLoading) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.LOADING, {
    groupBy, getJobWorksKanbanPageLoading,
  })

  /**
   *
   * @param kanbanJobWorks
   * @returns {{type: *}}
   */
  getJobWorksKanbanPageSuccess = (groupBy, jobWorks, previousPage, page, groupName, count) => action(jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.SUCCESS, {
    groupBy, jobWorks, previousPage, page, groupName, count,
  })

  getMasterProductionProcessKanban = (payload, callback) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.REQUEST, {
    payload, callback,
  })

  getMasterProductionProcessKanbanLoading = (getMasterProductionProcessKanbanLoading) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.LOADING, {
    getMasterProductionProcessKanbanLoading,
  })

  /**
   *
   * @param kanbanJobWorks
   * @returns {{type: *}}
   */
  getMasterProductionProcessKanbanSuccess = (groupBy, masterProductionProcess) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.SUCCESS, {
    groupBy, masterProductionProcess,
  })

  getMasterProductionProcessKanbanPage = (payload, callback) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.REQUEST, {
    payload, callback,
  })

  getMasterProductionProcessKanbanPageLoading = (groupBy, getMasterProductionProcessKanbanPageLoading) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.LOADING, {
    groupBy, getMasterProductionProcessKanbanPageLoading,
  })

  getMasterProductionProcessKanbanPageSuccess = (groupBy, masterProductionProcess, previousPage, page, groupName, count) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.SUCCESS, {
    groupBy, masterProductionProcess, previousPage, page, groupName, count,
  })

  getSubJobCardsKanban = (payload, callback) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.REQUEST, {
    payload, callback,
  })

  getSubJobCardsKanbanLoading = (getSubJobCardsKanbanLoading) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.LOADING, {
    getSubJobCardsKanbanLoading,
  })

  getSubJobCardsKanbanSuccess = (groupBy, subJobCards) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.SUCCESS, {
    groupBy, subJobCards,
  })

  getSubJobCardsKanbanPage = (payload, callback) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.REQUEST, {
    payload, callback,
  })

  getSubJobCardsKanbanPageLoading = (groupBy, getSubJobCardsKanbanPageLoading) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.LOADING, {
    groupBy, getSubJobCardsKanbanPageLoading,
  })

  getSubJobCardsKanbanPageSuccess = (groupBy, subJobCards, previousPage, page, groupName, count) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.SUCCESS, {
    groupBy, subJobCards, previousPage, page, groupName, count,
  })

  processJwMaterial = (payload, callback) => action(jobWorkActionTypes.PROCESS_JW_MATERIAL.REQUEST, {
    payload, callback,
  })

  processJwMaterialLoading = (processJwMaterialLoading) => action(jobWorkActionTypes.PROCESS_JW_MATERIAL.LOADING, {
    processJwMaterialLoading,
  })

  processJwMaterialComplete = (payload, callback) => action(jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.REQUEST, {
    payload, callback,
  })

  processJwMaterialCompleteLoading = (processJwMaterialCompleteLoading) => action(jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.LOADING, {
    processJwMaterialCompleteLoading,
  })

  getMasterProductionProcessList = (payload, callback) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.REQUEST, {
    payload, callback,
  });

  getMasterProductionProcessListLoading = (getMasterProductionProcessListLoading) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.LOADING, {
    getMasterProductionProcessListLoading,
  });

  getMasterProductionProcessListSuccess = (masterProductionProcessList) => action(jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.SUCCESS, {
    masterProductionProcessList,
  });

  getSubJobCardsList = (payload, callback) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.REQUEST, {
    payload, callback,
  });

  getSubJobCardsListLoading = (getSubJobCardsListLoading) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.LOADING, {
    getSubJobCardsListLoading,
  });

  getSubJobCardsListSuccess = (subJobCards) => action(jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.SUCCESS, {
    subJobCards,
  });
}

export default new JobWorkActions();
